// extracted by mini-css-extract-plugin
var _1 = "Tooltip_labelWithInfoIconTooltip__aAUSH";
var _2 = "Tooltip_labelWithInfoIconTooltipRoot__+n14p";
export { _1 as "labelWithInfoIconTooltip", _2 as "labelWithInfoIconTooltipRoot" }
